// extracted by mini-css-extract-plugin
module.exports = {"item":"list-network_item__2uEXx","front":"list-network_front__3WaQc","name":"list-network_name__2FVUd"};